import { render, staticRenderFns } from "./NewWaistItem.vue?vue&type=template&id=675510f8&scoped=true&"
import script from "./NewWaistItem.vue?vue&type=script&lang=js&"
export * from "./NewWaistItem.vue?vue&type=script&lang=js&"
import style0 from "./NewWaistItem.vue?vue&type=style&index=0&id=675510f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675510f8",
  null
  
)

export default component.exports